module.exports = __webpack_public_path__ + "img/jiaotong.1c9d8f6f.jpg";